export default __webpack_public_path__ + "static/media/logo22.730b0ccd.svg";